import axiosInstance from '../../../config/axiosInstance';
const  SupplierContactService = {
    async GetAllSupplierContacts(redirectCallback,ID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/Supplier/GetAllSupplierContacts?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSupplierContact(redirectCallback,ID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/DeleteSupplierContact?ID=${ID}`);
            return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierContactService;